export default "__VITE_ASSET__SQGD1jao__"